import uuidv1 from 'uuid/v1';

export const POPUP_SHOW = 'POPUP_SHOW';
export const POPUP_HIDE = 'POPUP_HIDE';
export const POPUP_DELETE_ALL = 'POPUP_DELETE_ALL';
export const POPUP_SHOW_HIDDEN = 'POPUP_SHOW_HIDDEN';
export const POPUP_DELETE = 'POPUP_DELETE';

export const popupShow = (message, {key, display, text} = {}) => async dispatch => {
  if (!key && key !== 0) key = uuidv1();
  await dispatch({ type: POPUP_SHOW, payload: { message, key, display, text } });
  return key;
};

export const popupHide = (key) => async dispatch => {
  dispatch({ type: POPUP_HIDE, payload: { key } });
};

export const popupShowHidden = (key) => async dispatch => {
  dispatch({ type: POPUP_SHOW_HIDDEN, payload: { key } });
};

export const popupDelAll = () => async dispatch => {
  dispatch({ type: POPUP_DELETE_ALL });
};

export const popupDel = (key) => async dispatch => {
  dispatch({ type: POPUP_DELETE, payload: { key } });
};


// WEBPACK FOOTER //
// ./src/actions/popup.js